import { z } from 'zod';
import type { TFunction } from 'i18next';

// Date/time/type are handled as plain component state (via `EventDatePicker`,
// same as the ficha) rather than RHF fields — `type` is derived from `allDay`
// on submit (milestone ⇄ all-day, time-entry ⇄ timed), never asked separately.
export const createCalendarEventSchema = (t: TFunction) =>
  z.object({
    title: z.string().min(1, t('createEvent.errors.titleRequired')),
    location: z.string().optional(),
    modality: z
      .enum(['virtual', 'in-person', 'hybrid'] as const)
      .nullable()
      .optional(),
    description: z.string().optional(),
  });

export type CalendarEventFormValues = z.infer<ReturnType<typeof createCalendarEventSchema>>;

export const updateLinkedCalendarSchema = z
  .object({
    scope: z.enum(['Global', 'Tenant'] as const),
    tenantId: z.string().optional(),
    syncEnabled: z.boolean(),
    colorHex: z
      .string()
      .regex(/^#[0-9A-Fa-f]{6}$/)
      .optional(),
  })
  .superRefine((data, ctx) => {
    if (data.scope === 'Tenant' && !data.tenantId) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['tenantId'],
        message: 'calendar:integrations.form.validation.tenantRequired',
      });
    }
  });

export type UpdateLinkedCalendarInput = z.infer<typeof updateLinkedCalendarSchema>;
